module.exports = __webpack_public_path__ + "media/images/athletes/1899-f5834c06af8d261d06cb41471c8180e7.png";